module.exports = __webpack_public_path__ + "assets/78.jpg?e9946bcabf69c41c6768c9b30263ebb0";